import { render, staticRenderFns } from "./BookDetailPage.vue?vue&type=template&id=4dc108b7&scoped=true"
import script from "./BookDetailPage.vue?vue&type=script&lang=js"
export * from "./BookDetailPage.vue?vue&type=script&lang=js"
import style0 from "./BookDetailPage.vue?vue&type=style&index=0&id=4dc108b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc108b7",
  null
  
)

export default component.exports